import React from 'react'
import { Box } from 'components/Layout'
import Card from 'components/Card'
import { UserCodeAvatar } from 'components/UserCodeAvatar'
import Button from 'components/Button'
import { Dialog } from '../../components/Dialog'

export interface Params {
  userId: string
  isBarcode?: boolean
}

export const ShowUserCode: React.VFC<Params> = ({ userId, isBarcode = false }) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  const handleDialogClose = React.useCallback(() => {
    setIsModalOpen(false)
  }, [])
  return (
    <>
      <Button onClick={() => setIsModalOpen(true)}>
        {isBarcode ? 'Show Barcode' : 'Check QR code'}
      </Button>
      <Dialog variant="center" isOpen={isModalOpen} onDismiss={handleDialogClose} maxWidth="512px">
        <Card.Title onDismiss={handleDialogClose}>{isBarcode ? 'Barcode' : 'QR code'}</Card.Title>
        <Box display="flex" justifyContent="center" alignItems="center" padding="0.25rem">
          <UserCodeAvatar isBarcode={isBarcode} userId={userId} size="XL" />
        </Box>
      </Dialog>
    </>
  )
}
